export default Object.freeze({
  priority: 999,
  faceIcon: {
    1: 'sentiment_very_dissatisfied',
    2: 'sentiment_dissatisfied',
    3: 'sentiment_satisfied',
    4: 'mood',
    5: 'sentiment_very_satisfied'
  },
  isTeams: /Teams/.test(navigator.userAgent),
  status: {
    constant: '-',
    new: '新規',
    edit: '編集',
    delete: '削除'
  },
  import: {
    run: {
      none: '',
      organization: 'organization'
    }
  },
  mailPath: {
    teams: 'teams',
    work: 'work'
  },
  tenantStatus: {
    ACTIVATED: 'ACTIVATED',
    INVALID: 'INVALID',
    VALIDITY: 'VALIDITY',
    PREPARING: 'PREPARING',
    REGISTRATION: 'REGISTRATION'
  }
})



// WEBPACK FOOTER //
// ./src/utils/const.js